var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaEnkeltBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.89,
    height: 24.568,
    viewBox: "0 0 16.89 24.568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bulb",
    transform: "translate(-260.623 -75.106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-lightbulb",
    "data-name": "Icon awesome-lightbulb",
    d: "M9.926,24.568H6.965a1.535,1.535,0,0,1-1.278-.685l-.82-1.233a1.536,1.536,0,0,1-.257-.849l0-1.84h7.676l0,1.84a1.535,1.535,0,0,1-.257.849l-.82,1.233A1.535,1.535,0,0,1,9.926,24.568Zm2.364-6.142H4.6c0-.012,0-.025-.005-.037A13.789,13.789,0,0,0,2.09,14a8.443,8.443,0,1,1,14.8-5.555A8.4,8.4,0,0,1,14.8,14a13.789,13.789,0,0,0-2.505,4.388C12.293,18.4,12.291,18.413,12.289,18.426Z",
    transform: "translate(260.623 75.106)",
    fill: "#222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-lightbulb-2",
    "data-name": "Icon awesome-lightbulb",
    d: "M8.445,3.071A5.38,5.38,0,0,0,3.071,8.445a.768.768,0,0,0,1.535,0A3.843,3.843,0,0,1,8.445,4.606a.768.768,0,1,0,0-1.535Z",
    transform: "translate(260.552 75.129)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaEnkeltBulb);
export default __webpack_public_path__ + "static/media/sa-enkelt-bulb.622779b2c56a85676e3a6cd5a73c58c4.svg";
export { ForwardRef as ReactComponent };